import React, { useState, useEffect } from 'react';
import apiService from '../../../services/apiService';
import { useParams } from 'react-router-dom';
import CustomToast from '../../Toast';
import Modal from 'react-modal';
import { useDropzone } from 'react-dropzone';
import POSHComplianceModal from '../modal/poshComplianceModal';
import OrganisationPrivacyModal from '../modal/organisationPrivacyModal';
import Loader from '../../layouts/loader';

const Compliance = () => {

  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [previewUrls, setPreviewUrls] = useState([]);
  const { id } = useParams();
  const [complianceData, setComplianceData] = useState([]);
  const [isAppointmentModalOpen, setAppointmentModalOpen] = useState(false);
  const [isPoshCompilanceModalOpen, setPoshCompilanceModalOpen] = useState(false);
  const [isOrganisationPrivacyModalOpen, setOrganisationPrivacyModalOpen] = useState(false);
  const [userData, setUserData] = useState(false);
  const [templateList, setTemplateList] = useState([])
  let orgInfo = JSON.parse(localStorage.getItem("orgInfo"));
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [loader, setLoader] = useState(false);
  const [confirm, setConfirm] = useState(false);
  const [currentDocType, setCurrentDocType] = useState('');
  const [category, setCategory] = useState('policy');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [complianceDocData, setComplianceDocData] = useState([]);
  const [initialSelectedOptions, setInitialSelectedOptions] = useState([]);


  useEffect(() => {
   
    const currentComplianceId = localStorage.getItem('currentComplianceId');
    if (currentComplianceId && currentComplianceId !== id) {
      localStorage.setItem('currentComplianceId', id);
      window.location.reload();
      return;
    }
    localStorage.setItem('currentComplianceId', id);

    const fetchComplianceData = async () => {
      setLoader(true);
      try {
        const token = apiService.getAuthToken();

        const complianceRes = await apiService.get(
          `get-compliance-list?compliance_id=${id}`,
          token
        );
        const complianceList = complianceRes.data.complianceList;
        setComplianceData(complianceList);
        setLoader(false);

        if (complianceList?.[0]?.questions?.length && selectedOptions) {
          await handleSelectedCompliances(id, complianceList[0].questions);
          setLoader(false);
        }

      } catch (error) {
        setLoader(false);
        CustomToast.error("Failed to load compliance data.");
      }
    };

    if (id) {
      fetchComplianceData();
    }

    fetchData();
    handleCompilanceConfirm();
  }, [id]);

  useEffect(() => {
    requestAnimationFrame(() => {
      window.scrollTo(0, 0);
    });
    fetchComplianceDocData();
    
    // Check compliance status on component mount
    const checkInitialCompliance = async () => {
      try {
        const token = apiService.getAuthToken();
        const result = await apiService.get(`get-compliance-list?org_id=${orgInfo?.org_id}`, token);

        if (result?.status === "success") {
          if (result?.data?.complianceConfirmed?.is_confirmed === "yes") {
            setConfirm(true);
            setPoshCompilanceModalOpen(false);
          } else {
            setConfirm(false);
            setPoshCompilanceModalOpen(true);
          }
        } else {
          setConfirm(false);
          setPoshCompilanceModalOpen(true);
        }
      } catch (error) {
        console.error(error);
        setConfirm(false);
        setPoshCompilanceModalOpen(true);
      }
    };

    checkInitialCompliance();
  }, []);

  const fetchComplianceDocData = async () => {
    const token = apiService.getAuthToken();
    try {
      const response = await apiService.get(
        `get-compliances-document?org_id=${orgInfo?.org_id}`,
        token
      );
      setComplianceDocData(response.data);

      console.log("ComplianceDocData", response.data[0]?.uploadDocument)
    } catch (error) {
      CustomToast.error("Error fetching compliance data");
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const menuTitle = complianceData?.[0]?.menu_title;

    if (!menuTitle) return;

    const category = menuTitle === "POSH Policy"
      ? "policy"
      : menuTitle === "Visibility & Posters"
        ? "poster"
        : menuTitle === "Training & Awareness"
          ? "email_campaign"
          : menuTitle === "Internal Committee"
            ? "ic_template"
            : menuTitle === "Documentation"
              ? "annual_report"
              : "policy";

    fetchTemplateList(category);
  }, [complianceData]);

  const fetchTemplateList = (category) => {
    setLoader(true);
    const token = apiService.getAuthToken();
    apiService.get(`get-template-list?category=${category}`, token).then(
      (response) => {
        setTemplateList(response?.data);
        setLoader(false);
      },
      (error) => {
        CustomToast.error("Error fetching template list");
        setLoader(false);
      }
    );
  };

  const onDrop = async (acceptedFiles) => {
    const maxFileSize = 10 * 1024 * 1024; // 10MB

    // Filter out oversized files
    const validFiles = acceptedFiles.filter(file => file.size <= maxFileSize);

    if (validFiles.length > 0) {
      setSelectedFiles(validFiles); // use a plural variable
      const previewUrls = await Promise.all(
        validFiles.map(file => {
          return new Promise(resolve => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(file);
          });
        })
      );
      setPreviewUrls(previewUrls); // array of base64 previews
    } else {
      setSelectedFiles([]);
      setPreviewUrls([]);
      CustomToast.error('Please choose valid files (each max size: 10MB).');
    }
  };

  const { fileRejections, getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      'application/pdf': ['.pdf'],
      'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx'],
      'application/msword': ['.doc'],
      'application/images': ['.png', '.jpg', '.jpeg'],
    }
  });

  const openPoshCompilanceModal = () => {
    setPoshCompilanceModalOpen(true);
  };

  const closePoshCompilanceModal = () => {
    setPoshCompilanceModalOpen(false);
  };

  const openOrganisationPrivacyModal = () => {
    setOrganisationPrivacyModalOpen(true);
  };

  const closeOrganisationPrivacyModal = () => {
    setOrganisationPrivacyModalOpen(false);
  };

  const openVideoModal = (docType) => {
    setCurrentDocType(docType);
    setModalOpen(true);
  };

  const closeVideoModal = () => {
    setModalOpen(false);
    setSelectedFiles([]);
  };

  const openAppointmentModal = () => {
    setAppointmentModalOpen(true);
  };

  const closeAppointmentModal = () => {
    setAppointmentModalOpen(false);
  };

  const fetchData = async () => {
    try {
      const token = apiService.getAuthToken()
      const result = await apiService.get('get-org-user-info', token);
      if (result && result?.status == "success") {
        setUserData(result?.data);
      }
    } catch (error) {
      //  setError('Error fetching user data');
      console.error(error);
    }
  };

  const sendAcceptance = async () => {
    try {
      const data = {
        org_id: orgInfo?.org_id,
        user_id: userData?.uid,
        is_comfirnmed: 'yes'
      };

      const token = apiService.getAuthToken();
      const response = await apiService.post('submit-compliances', data, token);

      if (response && response.status === 'success') {
        closePoshCompilanceModal();
        setConfirm(true);
        handleCompilanceConfirm();
        CustomToast.success('User accepted.');
      } else {
        CustomToast.error('Something went wrong');
        closePoshCompilanceModal();
      }
    } catch (error) {
      console.error(error);
      CustomToast.error('Something went wrong');
      closePoshCompilanceModal();
    }
  };


  const handleCompilanceConfirm = async () => {
    try {
      const token = apiService.getAuthToken();
      const result = await apiService.get(`get-compliance-list?org_id=${orgInfo?.org_id}`, token);

      if (result?.status === "success") {
        if (result?.data?.complianceConfirmed?.is_confirmed === "yes") {
          setConfirm(true);
          setPoshCompilanceModalOpen(false); 
        } else {
          setConfirm(false);
          setPoshCompilanceModalOpen(true);
        }
      } else {
        CustomToast.error('No compliance data found.');
        setPoshCompilanceModalOpen(true); 
      }
    } catch (error) {
      console.error(error);
      setPoshCompilanceModalOpen(true);
    }
  };

  const handleUploadDocument = async () => {
    if (!selectedFiles || selectedFiles.length === 0) {
      CustomToast.error('Please select at least one file to upload.');
      return;
    }

    const compliance = complianceData[0];

    const formData = new FormData();
    formData.append('org_id', orgInfo?.org_id);
    formData.append('compliance_id', compliance?.compliance_id);
    formData.append('compliance_title', compliance?.menu_title);
    formData.append('title', compliance?.title);
    formData.append('doc_type', currentDocType);

    selectedFiles.forEach(file => {
      formData.append('files', file, file.name);
    });

    try {
      setLoader(true);
      const token = apiService.getAuthToken();
      const response = await apiService.postFormdata('submit-compliances-document', formData, token);

      if (response && response.status === 'success') {
        setLoader(false);
        CustomToast.success('Files uploaded successfully.');
        closeVideoModal();
        setTimeout(() => {
          window.location.reload();
        }, 1000);
        setSelectedFiles([]);
        setPreviewUrls([]);
        setConfirm(true);
      } else {
        CustomToast.error('Error uploading files.');
      }
      setLoader(false);
    } catch (error) {
      console.error(error);
      CustomToast.error('Error uploading files.');
    }
  };

  const handleCheckboxChange = (optionId) => {
    setSelectedOptions((prev) => {
      const newSelectedOptions = prev.includes(optionId)
        ? prev.filter((id) => id !== optionId)
        : [...prev, optionId];

      // Determine if submit button should be enabled
      const hasInitialData = initialSelectedOptions.length > 0;
      const hasCurrentSelections = newSelectedOptions.length > 0;
      const hasChanges = JSON.stringify(newSelectedOptions.sort()) !== JSON.stringify(initialSelectedOptions.sort());

      if (!hasInitialData) {
        // No previous data - enable only when something is selected
        setIsSubmitted(!hasCurrentSelections);
      } else {
        // Has previous data - enable when there are changes
        setIsSubmitted(!hasChanges);
      }

      return newSelectedOptions;
    });
  };

  const handleSubmit = async () => {
    try {
      if (!complianceData?.[0]?.questions?.length) {
        CustomToast.error('No compliance questions available.');
        return;
      }

      const data = {
        org_id: orgInfo?.org_id,
        user_id: userData?.uid,
        selectedCompliance: [{
          compliance_id: complianceData?.[0]?.compliance_id,
          selectedOptions: selectedOptions
        }]
      };

      setLoader(true);
      setIsSubmitted(true); // Disable button during submission
      const token = apiService.getAuthToken();
      const response = await apiService.post('submit-compliances', data, token);

      if (response && response.status === 'success') {
        CustomToast.success('Submitted successfully.');
        // Update initial state to current selection after successful submission
        setInitialSelectedOptions([...selectedOptions]);
        setLoader(false);
      } else {
        CustomToast.error('Something went wrong');
        setIsSubmitted(false); // Re-enable button on error
        setLoader(false);
      }

    } catch (error) {
      console.error(error);
      CustomToast.error('Something went wrong');
      setIsSubmitted(false); // Re-enable button on error
      setLoader(false);
    }
  };


  const handleSelectedCompliances = async (complianceId) => {
    try {
      const token = apiService.getAuthToken();
      const result = await apiService.get(
        `get-selected-compliances?org_id=${orgInfo?.org_id}&compliance_id=${complianceId}`,
        token
      );

      if (result?.status === "success" && Array.isArray(result?.data)) {
        setSelectedOptions(result?.data);
        setInitialSelectedOptions(result?.data); // Store initial state
        if (result?.data?.length > 0) {
          setIsSubmitted(true);
        } else {
          setIsSubmitted(false);
        }
      }
    } catch (error) {
      console.error(error);
      // CustomToast.error("Error loading selected compliances.");
    }
  };

  // Calculate total checklist items and progress
  const calculateProgress = () => {
    if (!complianceData[0]?.questions) return { completed: 0, total: 0, percentage: 0 };
    
    let totalItems = 0;
    complianceData[0].questions.forEach(question => {
      if (question.options && Array.isArray(question.options)) {
        totalItems += question.options.length;
      }
    });

    const completedItems = selectedOptions.length;
    const percentage = totalItems > 0 ? Math.round((completedItems / totalItems) * 100) : 0;

    return {
      completed: completedItems,
      total: totalItems,
      percentage: percentage
    };
  };

  const progress = calculateProgress();

  const handleScheduleAppointment = async () => {
    setLoader(true);
    try {
      const data = {
        orgName: orgInfo?.org_name,
        adminFullName: userData?.name,
        emailAddress: userData?.email,
        phoneNumber: userData?.mobile
      };

      const token = apiService.getAuthToken();
      const response = await apiService.post('schedule-appointment', data, token);

      if (response && response.status === 'success') {
        closeAppointmentModal();
        setLoader(false);
        CustomToast.success('Appointment scheduled successfully.');
      } else {
        setLoader(false);
        CustomToast.error('Failed to schedule appointment.');
        closeAppointmentModal();
      }
    } catch (error) {
      CustomToast.error('Failed to schedule appointment.');
      closeAppointmentModal();
    }
  };

  const handleDeleteDoc = async (complianceId, docType, doc) => {
    const data = {
      org_id: orgInfo.org_id,
      compliance_id: complianceId,
      doc_type: docType,
      upload_url_id: doc.upload_url_id,
    };

    const token = apiService.getAuthToken();
    try {
      await apiService.delete(`/delete-compliances-document`, data, token);
      CustomToast.success("Document deleted");
      fetchComplianceDocData();
    } catch (error) {
      CustomToast.error("Failed to delete document");
    }
  };

  return (

    <div className='page__main'>
      <div className="dashboard" style={{ minHeight: '100vh' }}>
        <div className="container-fluid compliance-checklist">

          <div className="row mb-4">
            {/* <h4 className='text-black font-weight-600 px-0'>Compliance &gt; {complianceData[0]?.title}</h4> */}
             <h4 className='text-black font-weight-600 px-0'>POSH Policy</h4>
            <p className='font-16 px-0'>{complianceData[0]?.description}</p>
          </div>
          {loader ?
            <Loader /> :
            <div className="row">

              {/* <div className={complianceData[0]?.menu_title === "Redressal" ?
                "col-md-12 bg-white border-radius-20 px-0 d-none"
                : "col-md-8 bg-white border-radius-20 px-0"
              }>
                <div className="card card-body px-0 pt-0 pb-0 bg-white">
                  <div className='d-flex justify-content-between align-items-center px-4 py-3'>
                    <h5 className="bg-white text-black border-radius-20 font-weight-600 font-26 w-75 mb-0">
                      {complianceData[0]?.title}
                    </h5>
                    <div className='w-25 mt-2'>
                      <div className="progress mb-1" style={{ height: '6px' }}>
                        <div
                          className="progress-bar"
                          role="progressbar"
                          aria-valuenow={progress.percentage}
                          aria-valuemin="0"
                          aria-valuemax="100"
                          style={{
                            width: `${progress.percentage}%`,
                            backgroundColor: progress.percentage === 100 ? 'rgb(36, 161, 152)' : 'rgb(36, 161, 152)'
                          }}
                        ></div>
                      </div>
                      <div className="d-flex justify-content-start align-items-center">
                        <div className="small fw-regular text-muted">{progress.completed} out of {progress.total} completed</div>
                      </div>
                    </div>
                  </div>
                  <div className='border-bottom'></div>
                </div>

                <div className='compliance-questions'>
                  {complianceData[0]?.questions?.length > 0 && (complianceData[0].questions.map((question, qIndex) => (
                    <div className="card-body py-3" key={qIndex}>
                      <h5 className="font-weight-600 primary_color font-20 mb-4">{question?.subTitle}</h5>
                      <p className="mb-2 p-2" style={{ background: '#f4f4f4', display: 'inline-block', borderRadius: '4px' }}>
                        <span className="text-dark small d-flex align-items-center">
                          <img src='/images/timer.svg' alt='timer' width={16} className='me-1' />       
                          {question?.subDescription}
                        </span>
                      </p>

                      {question?.options?.map((item, index) => (
                        <div className="form-check compliance-checklist border-bottom mt-3 mb-2" key={index}>
                          <input
                            type="checkbox"
                            className="form-check-input"
                            id={`item-${qIndex}-${index}`}
                            value={item._id}
                            checked={selectedOptions.includes(item._id)}
                            onChange={() => handleCheckboxChange(item._id)}
                            disabled={orgInfo?.plan_id == 'plan_1234567890'}
                          />

                          <label className="form-check-label" htmlFor={`item-${qIndex}-${index}`}>
                           <span>
                            {(() => {
                              const contentToShow = item?.content;
                              if (contentToShow && contentToShow?.includes('\n')) {
                                const [normalText, ...bullets] = contentToShow?.split(/\n/);
                                return (
                                  <>
                                    {normalText.trim()}
                                    <ul style={{ marginBottom: '0.5rem', marginTop: '0.5rem' }}>
                                      {bullets
                                        .map(point => point?.trim())
                                        .filter(point => point?.length > 0)
                                        .map((point, idx) => (
                                          <li key={idx}>{point}</li>
                                        ))}
                                    </ul>
                                  </>
                                );
                              } else {
                                return contentToShow;
                              }
                            })()}
                            </span>
                            {item?.tag && (
                              <span
                                className={`badge compilance ms-2 ${item?.tag === 'Must Have' ? 'bg-danger' : item?.tag === 'Highly Recommended' ? 'bg-warning' : 'bg-success'}`}
                                style={{ width: 'fit-content' }}
                              >
                                {item.tag}
                              </span>
                            )}
                          </label>
                        </div>
                      ))}
                    </div>
                  ))
                  )}
                </div>

                <div className="text-end pb-4 px-4">
                  <button className="btn btn-primary btn-md border-radius-50 px-5 py-2" onClick={handleSubmit} disabled={isSubmitted}>
                    Submit
                  </button>
                </div>
              </div> */}

              {complianceData[0]?.menu_title === "POSH Policy" &&
                <div className="col-md-12 pe-0">
                  <div className="card mb-4 h-100">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom py-4 px-4 my-0'>Upload Documents</h5>

                      {(() => {
                        const poshPolicy = complianceDocData.find(item => item.compliance_title === "POSH Policy");

                        const hasDocuments =
                          poshPolicy &&
                          poshPolicy.uploadDocument &&
                          poshPolicy.uploadDocument.some(
                            docGroup => docGroup.documents && docGroup.documents.length > 0
                          );

                        if (!hasDocuments) {
                          // Case: Documents are not present
                          return (
                            <div className='px-4'>
                              <h3 className='mt-4 mb-4'>POSH Policy</h3>
                              <div className='mb-2 d-flex justify-content-between align-items-center'>
                                <button
                                  className="btn btn-outline-primary small py-0 pe-0 w-100 text-black d-flex justify-content-between align-items-center"
                                  onClick={() => openVideoModal('posh_policy')}
                                  style={{ backgroundColor: '#F8F8F8' }}
                                >
                                  Upload your organisation POSH policy
                                  <img src='/images/upload.svg' alt='upload' />
                                </button>
                              </div>
                            </div>
                          );
                        }
                      })()}

                      {complianceDocData
                        .filter(compliance => compliance.compliance_title === "POSH Policy")
                        .map((compliance, index) => {
                          const groupedByDocType = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                            if (!acc[uploadDoc.doc_type]) {
                              acc[uploadDoc.doc_type] = [];
                            }
                            acc[uploadDoc.doc_type].push(uploadDoc);
                            return acc;
                          }, {});

                          return (
                            <div className="px-3 pt-0 pb-4 mb-4 border-bottom" key={index}>
                              {Object.entries(groupedByDocType).map(([docType, docItems], groupIndex) => (
                                <div key={groupIndex}>
                                  <div className="px-3">
                                    {docItems.map((uploadDoc, docIndex) => (
                                      <div key={docIndex}>
                                        <div className='d-flex justify-content-between align-items-center my-2'>
                                          <p className="mt-2 mb-1">
                                            <p className="fw-regular text-capitalize mb-0">
                                              POSH Policy
                                            </p>
                                          </p>
                                          {/* <p className='mb-0'>
                                            <a href='javascript:void(0)'
                                              onClick={() => openVideoModal('posh_policy')}
                                              className='mt-3'
                                              style={{ color: '#23A298', textDecoration: 'none' }}
                                            >
                                              <img src='/images/add-circle.svg' alt='Add' className='me-1' />Add
                                            </a>
                                          </p> */}
                                        </div>

                                        {uploadDoc.documents.map((doc, fileIndex) => (
                                          <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                            <img
                                              src={
                                                  doc.file_type === "pdf"
                                                    ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                    : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                }
                                              alt={doc.file_type}
                                              width="25"
                                              className="me-2 py-1"
                                            />
                                            <div className="flex-grow-1" style={{ wordBreak: 'break-word' }}>{doc.file_name}</div>

                                            <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                              <img src="/images/download-icon.svg" alt="Download" />
                                            </a>

                                            <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                              e.preventDefault();
                                              handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                            }}>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                              </svg>
                                            </a>
                                          </div>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          );
                        })}

                      <small className="d-block text-muted mx-4">
                        Your organisation privacy matters – <a href="javascript:void(0);" onClick={openOrganisationPrivacyModal} className="text-muted">learn why we use or collect this information?</a>
                      </small>
                    </div> </div>

                  {/* <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom mt-0 py-3 px-4 mb-4'>View Templates</h5>
                      <div className="d-flex justify-content-start w-100 px-3">
                        {templateList.length > 0 ? (
                          <div className="template-library" style={{ display: 'flex', flexDirection: 'row', justifyContent: templateList?.length > 1 ? 'space-evenly' : 'flex-start' }}>
                            {templateList?.slice(0, 2)?.map(template => (
                              <div key={template.id} class="card rounded-4 p-1 col-5 shadow-sm my-2">
                                <img src={template?.thumbnail} alt="template-img" className="img-fluid" />
                                 <h4 className='mt-2 fw-bold' style={{ fontSize: '10px' }}>{template?.title}</h4>
                                  <div className='d-flex flex-wrap align-items-center justify-content-start'>
                        {template?.upload_url?.slice(0, 2).map((file, index) => {
                          const isImageFile = file?.type && (
                            file.type.toLowerCase().includes('png') || 
                            file.type.toLowerCase().includes('jpg') || 
                            file.type.toLowerCase().includes('jpeg') || 
                            file.type.toLowerCase().includes('image')
                          );

                          return isImageFile ? (
                             <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>

                          ) : (
                            <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>
                          );
                        })}
                      </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No templates found.</p>
                        )}
                      </div>
                      <div className='text-center'>
                         <a href='/template_library/policy' className={`btn btn-link btn-primary text-white text-decoration-none btn-sm w-75 mt-3 mx-auto`}>View All</a>
                      </div>
                    </div>
                  </div>

                  <div className="card">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom mt-0 py-3 px-4 mb-4'>Get your policy reviewed by our expert!</h5>
                      <div className="px-4">
                        <p className="small">
                          Get your POSH policy reviewed by experts to ensure legal compliance, clarity, and effectiveness—customised to your organisation’s needs.
                        </p>
                        <ul className="small ps-0" style={{ listStyle: 'none' }}>
                          <li>✓ Aligned with the POSH Act</li>
                          <li>✓ Organisation-specific recommendations</li>
                          <li>✓ Clear, actionable, and accessible</li>
                          <li>✓ Stronger implementation strategies</li>
                        </ul>
                        <p className="small">Ensure a safe and compliant workplace with expert guidance! 🚀</p>
                      </div>

                      <div className='text-center'>
                        <button className="btn btn-md btn-danger py-2 w-75 font-18 px-0" onClick={openAppointmentModal}>Schedule an Appointment</button>
                        <Modal
                          isOpen={isAppointmentModalOpen}
                          onRequestClose={closeAppointmentModal}
                          contentLabel="Appointment Modal"
                          className='bg-white border-radius-20 p-4'
                        > 
                        <button type="button" className="close text-white" onClick={closeAppointmentModal}> <svg width="20" height="20" viewBox="0 0 29 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <rect x="0.548828" width="27.4625" height="27.4517" rx="13.7259" fill="#146B90" />
                          <path d="M19.619 17.6867C20.0081 18.0758 20.0081 18.6811 19.619 19.0702C19.4245 19.2647 19.1867 19.3512 18.9273 19.3512C18.6679 19.3512 18.4301 19.2647 18.2355 19.0702L14.2796 15.1143L10.3237 19.0702C10.1292 19.2647 9.89141 19.3512 9.63201 19.3512C9.3726 19.3512 9.13482 19.2647 8.94027 19.0702C8.55116 18.6811 8.55116 18.0758 8.94027 17.6867L12.8962 13.7308L8.94027 9.77492C8.55116 9.38582 8.55116 8.78054 8.94027 8.39144C9.32937 8.00233 9.93464 8.00233 10.3237 8.39144L14.2796 12.3473L18.2355 8.39144C18.6246 8.00233 19.2299 8.00233 19.619 8.39144C20.0081 8.78054 20.0081 9.38582 19.619 9.77492L15.6631 13.7308L19.619 17.6867Z" fill="white" />
                        </svg></button>
                          <div className="modal-body text-center px-3">
                            <div className="my-4">
                              <img src='/images/schedule-appointment.svg' alt='appointment' className='img-fluid' style={{ width: '150px', height: '150px' }} />
                            </div>
                            <h5 className="modal-title font-weight-600 mb-2">Schedule an appointment with our expert</h5>
                            <p>Are you sure you want to proceed? Our experts will reach out shortly after your request is sent.</p>
                            <p className='mb-4'><strong>Please note that this is a premium feature and will incur an additional charge.</strong></p>
                            <button type="button" className="btn btn-md btn-primary px-5 my-3" onClick={handleScheduleAppointment} style={{ backgroundColor: '#E53E3E' }} >Schedule an Appointment</button>
                          </div>
                        </Modal>

                      </div>
                    </div>
                  </div> */}

                </div>}

              {complianceData[0]?.menu_title === "Visibility & Posters" &&
                <div className="col-md-4 ps-4 pe-0">
                  <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom py-4 px-4 my-0'>Upload Documents</h5>

                      {(() => {
                        const visibilityPosters = complianceDocData.find(item => item.compliance_title === "Visibility & Posters");

                        const hasDocuments =
                          visibilityPosters &&
                          visibilityPosters.uploadDocument &&
                          visibilityPosters.uploadDocument.some(
                            docGroup => docGroup.documents && docGroup.documents.length > 0
                          );

                        if (!hasDocuments) {
                          // Case: Documents are not present
                          return (
                            <div className='px-4'>
                              <h3 className='mt-4 mb-4'>Visibility & Posters</h3>
                              <div className='mb-2 d-flex justify-content-between align-items-center'>
                                <button
                                  className="btn btn-outline-primary small py-0 pe-0 w-100 text-black d-flex justify-content-between align-items-center"
                                  onClick={() => openVideoModal('visibility_posters')}
                                  style={{ backgroundColor: '#F8F8F8' }}
                                >
                                  Upload your organisation Visibility & Posters
                                  <img src='/images/upload.svg' alt='upload' />
                                </button>
                              </div>
                            </div>
                          );
                        }
                      })()}


                      {complianceDocData
                        .filter(compliance => compliance.compliance_title === "Visibility & Posters")
                        .map((compliance, index) => {
                          const groupedByDocType = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                            if (!acc[uploadDoc.doc_type]) {
                              acc[uploadDoc.doc_type] = [];
                            }
                            acc[uploadDoc.doc_type].push(uploadDoc);
                            return acc;
                          }, {});

                          return (
                            <div className="px-3 pt-0 pb-4 mb-4 border-bottom" key={index}>
                              {Object.entries(groupedByDocType).map(([docType, docItems], groupIndex) => (
                                <div key={groupIndex}>
                                  <div className="px-3">
                                    {docItems.map((uploadDoc, docIndex) => (
                                      <div key={docIndex}>
                                        <div className='d-flex justify-content-between align-items-center my-2'>
                                          <p className="mt-2 mb-1">
                                            <p className="fw-regular text-capitalize mb-0">
                                              Visibility & Posters
                                            </p>
                                          </p>
                                          <p className='mb-0'>
                                            <a href='javascript:void(0)'
                                              onClick={() => openVideoModal('visibility_posters')}
                                              className='mt-3'
                                              style={{ color: '#23A298', textDecoration: 'none' }}
                                            >
                                              <img src='/images/add-circle.svg' alt='Add' className='me-1' />Add
                                            </a>
                                          </p>
                                        </div>

                                        {uploadDoc.documents.map((doc, fileIndex) => (
                                          <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                            <img
                                              src={
                                                  doc.file_type === "pdf"
                                                    ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                    : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                }
                                              alt={doc.file_type}
                                              width="25"
                                              className="me-2 py-1"
                                            />
                                            <div className="flex-grow-1" style={{ wordBreak: 'break-word' }}>{doc.file_name}</div>

                                            <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                              <img src="/images/download-icon.svg" alt="Download" />
                                            </a>

                                            <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                              e.preventDefault();
                                              handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                            }}>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                              </svg>
                                            </a>
                                          </div>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          );
                        })}
                      <small className="d-block text-muted mx-4">
                        Your organisation privacy matters – <a href="javascript:void(0);" onClick={openOrganisationPrivacyModal} className="text-muted">learn why we use or collect this information?</a>
                      </small>
                    </div></div>
                  <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom mt-0 py-3 px-4 mb-4'>View Templates</h5>
                      <div className="d-flex justify-content-start w-100 px-3">
                        {templateList.length > 0 ? (
                          <div className="template-library" style={{ display: 'flex', flexDirection: 'row', justifyContent: templateList?.length > 1 ? 'space-evenly' : 'flex-start' }}>
                            {templateList?.slice(0, 2)?.map(template => (
                              <div key={template.id} class="card rounded-4 p-1 col-5 shadow-sm my-2">
                                <img src={template?.thumbnail} alt="template-img" className="img-fluid" />
                                 <h4 className='mt-2 fw-bold' style={{ fontSize: '10px' }}>{template?.title}</h4>
                                          <div className='d-flex flex-wrap align-items-center justify-content-start'>
                        {template?.upload_url?.slice(0, 2).map((file, index) => {
                          const isImageFile = file?.type && (
                            file.type.toLowerCase().includes('png') || 
                            file.type.toLowerCase().includes('jpg') || 
                            file.type.toLowerCase().includes('jpeg') || 
                            file.type.toLowerCase().includes('image')
                          );

                          return isImageFile ? (
                            // <button
                            //   key={index}
                            //   onClick={() => handleDownload(file.url, `${template.title}.${file.type}`)}
                            //   className='btn btn-primary btn-sm px-1 pt-0 pb-1 mx-1 d-flex align-items-center'
                            // >
                            //   {file.type}
                            //   <img
                            //     src='/images/download-arrow.png'
                            //     alt='download-icon'
                            //     width={10}
                            //     height={10}
                            //     className='ms-1'
                            //   />
                            // </button>

                             <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>

                          ) : (
                            <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>
                          );
                        })}
                      </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No templates found.</p>
                        )}
                      </div>
                      <div className='text-center'>
                        <a href='/template_library/poster' className="btn btn-link btn-primary text-white text-decoration-none btn-sm w-75 mt-3 mx-auto" >View All</a>
                      </div>
                    </div>
                  </div>
                </div>}

              {complianceData[0]?.menu_title === "Internal Committee" &&
                <div className="col-md-4 ps-4 pe-0">
                  <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom py-4 px-4 my-0'>Upload Documents</h5>

                      {(() => {
                        const internalCommittee = complianceDocData.find(item => item.compliance_title === "Internal Committee");

                        const hasIcCompositionDocuments =
                          internalCommittee &&
                          internalCommittee.uploadDocument &&
                          internalCommittee.uploadDocument.some(
                            docGroup => docGroup.doc_type === "ic_composition" && docGroup.documents && docGroup.documents.length > 0
                          );

                        if (!hasIcCompositionDocuments) {
                          // Case: IC Composition Documents are not present - show title and upload button
                          return (
                            <div className='px-4'>
                              <h3 className='mt-4 mb-0'>IC Composition</h3>
                              <div className='py-3 px-1'>
                                <button className="btn btn-outline-primary small py-0 pe-0 w-100 text-black d-flex justify-content-between align-items-center" onClick={() => openVideoModal('ic_composition')} style={{ backgroundColor: '#F8F8F8' }}>Upload proof of IC Composition <img src='/images/upload.svg' alt='upload' /></button>
                              </div>
                            </div>
                          );
                        }
                      })()}

                      {complianceDocData
                        .filter(compliance => compliance.compliance_title === "Internal Committee")
                        .map((compliance, index) => {
                          const groupedByDocType = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                            if (!acc[uploadDoc.doc_type]) {
                              acc[uploadDoc.doc_type] = [];
                            }
                            acc[uploadDoc.doc_type].push(uploadDoc);
                            return acc;
                          }, {});

                          return (
                            <div className="px-3 pt-0 pb-4 mb-4 border-bottom" key={index}>
                              {Object.entries(groupedByDocType)
                                .filter(([docType]) => docType === "ic_composition")
                                .map(([docType, docItems], groupIndex) => (
                                  <div key={groupIndex}>
                                    <div className="px-3">
                                      {docItems.map((uploadDoc, docIndex) => (
                                        <div key={docIndex}>
                                          <div className='d-flex justify-content-between align-items-center my-2'>
                                            <p className="mt-2 mb-1">
                                              <p className="fw-regular text-capitalize mb-0">
                                                IC Composition
                                              </p>
                                            </p>
                                            <p className='mb-0'>
                                              <a href='javascript:void(0)'
                                                onClick={() => openVideoModal('ic_composition')}
                                                className='mt-3'
                                                style={{ color: '#23A298', textDecoration: 'none' }}
                                              >
                                                <img src='/images/add-circle.svg' alt='Add' className='me-1' />Add
                                              </a>
                                            </p>
                                          </div>

                                          {uploadDoc.documents.map((doc, fileIndex) => (
                                            <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                              <img
                                                src={
                                                  doc.file_type === "pdf"
                                                    ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                    : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                }
                                                alt={doc.file_type}
                                                width="25"
                                                className="me-2 py-1"
                                              />
                                              <div className="flex-grow-1" style={{ wordBreak: 'break-word' }}>{doc.file_name}</div>

                                              <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                                <img src="/images/download-icon.svg" alt="Download" />
                                              </a>

                                              <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                                e.preventDefault();
                                                handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                              }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                                </svg>
                                              </a>
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          );
                        })}


                      {(() => {
                        const internalCommittee = complianceDocData.find(item => item.compliance_title === "Internal Committee");

                        const hasIcRegistrationDocuments =
                          internalCommittee &&
                          internalCommittee.uploadDocument &&
                          internalCommittee.uploadDocument.some(
                            docGroup => docGroup.doc_type === "ic_registration" && docGroup.documents && docGroup.documents.length > 0
                          );

                        if (!hasIcRegistrationDocuments) {
                          // Case: IC Registration Documents are not present - show title and upload button
                          return (
                            <>
                              <h3 className='px-4 mt-4 mb-0'>IC Registration</h3>
                              <div className='px-4 py-3'>
                                <button className="btn btn-outline-primary small py-0 pe-0 w-100 text-black d-flex justify-content-between align-items-center" onClick={() => openVideoModal('ic_registration')} style={{ backgroundColor: '#F8F8F8' }}>Upload proof of IC Registration <img src='/images/upload.svg' alt='upload' /></button>
                              </div>
                            </>
                          );
                        }
                      })()}


                      {complianceDocData
                        .filter(compliance => compliance.compliance_title === "Internal Committee")
                        .map((compliance, index) => {
                          const groupedByDocType = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                            if (!acc[uploadDoc.doc_type]) {
                              acc[uploadDoc.doc_type] = [];
                            }
                            acc[uploadDoc.doc_type].push(uploadDoc);
                            return acc;
                          }, {});

                          return (
                            <div className="px-3 pt-0 pb-4 mb-4 border-bottom" key={index}>
                              {Object.entries(groupedByDocType)
                                .filter(([docType]) => docType === "ic_registration")
                                .map(([docType, docItems], groupIndex) => (
                                  <div key={groupIndex}>
                                    <div className="px-3">
                                      {docItems.map((uploadDoc, docIndex) => (
                                        <div key={docIndex}>
                                          <div className='d-flex justify-content-between align-items-center my-2'>
                                            <p className="mt-2 mb-1">
                                              <p className="fw-regular text-capitalize mb-0">
                                                IC Registration
                                              </p>
                                            </p>
                                            <p className='mb-0'>
                                              <a href='javascript:void(0)'
                                                onClick={() => openVideoModal('ic_registration')}
                                                className='mt-3'
                                                style={{ color: '#23A298', textDecoration: 'none' }}
                                              >
                                                <img src='/images/add-circle.svg' alt='Add' className='me-1' />Add
                                              </a>
                                            </p>
                                          </div>

                                          {uploadDoc.documents.map((doc, fileIndex) => (
                                            <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                              <img
                                                src={
                                                  doc.file_type === "pdf"
                                                    ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                    : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                }
                                                alt={doc.file_type}
                                                width="25"
                                                className="me-2 py-1"
                                              />
                                              <div className="flex-grow-1" style={{ wordBreak: 'break-word' }}>{doc.file_name}</div>

                                              <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                                <img src="/images/download-icon.svg" alt="Download" />
                                              </a>

                                              <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                                e.preventDefault();
                                                handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                              }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                                </svg>
                                              </a>
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          );
                        })}


                      {(() => {
                        const internalCommittee = complianceDocData.find(item => item.compliance_title === "Internal Committee");

                        const hasSheboxRegistrationDocuments =
                          internalCommittee &&
                          internalCommittee.uploadDocument &&
                          internalCommittee.uploadDocument.some(
                            docGroup => docGroup.doc_type === "shebox_registration" && docGroup.documents && docGroup.documents.length > 0
                          );

                        if (!hasSheboxRegistrationDocuments) {
                          // Case: SHe-box Registration Documents are not present - show title and upload button
                          return (
                            <>
                              <h3 className='px-4 mt-4 mb-0 mx-1'>SHe-box Registration</h3>
                              <div className='py-3 px-4 mx-1'>
                                <button className="btn btn-outline-primary small py-0 pe-0 w-100 text-black d-flex justify-content-between align-items-center" onClick={() => openVideoModal('shebox_registration')} style={{ backgroundColor: '#F8F8F8' }}>Upload proof of IC Registration on the SHe-box portal <img src='/images/upload.svg' alt='upload' /></button>
                              </div>
                            </>
                          );
                        }
                      })()}

                      {complianceDocData
                        .filter(compliance => compliance.compliance_title === "Internal Committee")
                        .map((compliance, index) => {
                          const groupedByDocType = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                            if (!acc[uploadDoc.doc_type]) {
                              acc[uploadDoc.doc_type] = [];
                            }
                            acc[uploadDoc.doc_type].push(uploadDoc);
                            return acc;
                          }, {});

                          return (
                            <div className="px-3 pt-0 pb-4 mb-4 border-bottom" key={index}>
                              {Object.entries(groupedByDocType)
                                .filter(([docType]) => docType === "shebox_registration")
                                .map(([docType, docItems], groupIndex) => (
                                  <div key={groupIndex}>
                                    <div className="px-3">
                                      {docItems.map((uploadDoc, docIndex) => (
                                        <div key={docIndex}>
                                          <div className='d-flex justify-content-between align-items-center my-2'>
                                            <p className="mt-2 mb-1">
                                              <p className="fw-regular text-capitalize mb-0">
                                                SHe-box Registration
                                              </p>
                                            </p>
                                            <p className='mb-0'>
                                              <a href='javascript:void(0)'
                                                onClick={() => openVideoModal('shebox_registration')}
                                                className='mt-3'
                                                style={{ color: '#23A298', textDecoration: 'none' }}
                                              >
                                                <img src='/images/add-circle.svg' alt='Add' className='me-1' />Add
                                              </a>
                                            </p>
                                          </div>

                                          {uploadDoc.documents.map((doc, fileIndex) => (
                                            <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                              <img
                                                src={
                                                  doc.file_type === "pdf"
                                                    ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                    : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                }
                                                alt={doc.file_type}
                                                width="25"
                                                className="me-2 py-1"
                                              />
                                              <div className="flex-grow-1" style={{ wordBreak: 'break-word' }}>{doc.file_name}</div>

                                              <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                                <img src="/images/download-icon.svg" alt="Download" />
                                              </a>

                                              <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                                e.preventDefault();
                                                handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                              }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                                </svg>
                                              </a>
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          );
                        })}


                      <small className="d-block text-muted mx-4">
                        Your organisation privacy matters – <a href="javascript:void(0);" onClick={openOrganisationPrivacyModal} className="text-muted">learn why we use or collect this information?</a>
                      </small>
                    </div></div>
                  <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom mt-0 py-3 px-4 mb-4'>View Templates</h5>
                      <div className="d-flex justify-content-start w-100 px-3">
                        {templateList.length > 0 ? (
                          <div className="template-library" style={{ display: 'flex', flexDirection: 'row', justifyContent: templateList?.length > 1 ? 'space-evenly' : 'flex-start' }}>
                            {templateList?.slice(0, 2)?.map(template => (
                              <div key={template.id} class="card rounded-4 p-1 col-5 shadow-sm my-2">
                                <img src={template?.thumbnail} alt="template-img" className="img-fluid" />
                                 <h4 className='mt-2 fw-bold' style={{ fontSize: '10px' }}>{template?.title}</h4>
                                          <div className='d-flex flex-wrap align-items-center justify-content-start'>
                        {template?.upload_url?.slice(0, 2).map((file, index) => {
                          const isImageFile = file?.type && (
                            file.type.toLowerCase().includes('png') || 
                            file.type.toLowerCase().includes('jpg') || 
                            file.type.toLowerCase().includes('jpeg') || 
                            file.type.toLowerCase().includes('image')
                          );

                          return isImageFile ? (
                            // <button
                            //   key={index}
                            //   onClick={() => handleDownload(file.url, `${template.title}.${file.type}`)}
                            //   className='btn btn-primary btn-sm px-1 pt-0 pb-1 mx-1 d-flex align-items-center'
                            // >
                            //   {file.type}
                            //   <img
                            //     src='/images/download-arrow.png'
                            //     alt='download-icon'
                            //     width={10}
                            //     height={10}
                            //     className='ms-1'
                            //   />
                            // </button>

                             <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>

                          ) : (
                            <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>
                          );
                        })}
                      </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No templates found.</p>
                        )}
                      </div>
                      <div className='text-center'>
                        <a href='/template_library/ic_template' className="btn btn-link btn-primary text-white text-decoration-none btn-sm w-75 mt-3 mx-auto">View All</a>
                      </div>
                    </div>
                  </div>

                </div>}

              {complianceData[0]?.menu_title === "Training & Awareness" &&
                <div className="col-md-4 ps-4 pe-0">
                  <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom py-4 px-4 my-0'>Upload Documents</h5>
                      {(() => {
                        const trainingAwareness = complianceDocData.find(item => item.compliance_title === "Training & Awareness");

                        const hasEmployeeTrainingDocuments =
                          trainingAwareness &&
                          trainingAwareness.uploadDocument &&
                          trainingAwareness.uploadDocument.some(
                            docGroup => docGroup.doc_type === "employee_training" && docGroup.documents && docGroup.documents.length > 0
                          );

                        if (!hasEmployeeTrainingDocuments) {
                          // Case: Employee Training Documents are not present - show title and upload button
                          return (
                            <div className='px-4'>
                              <h3 className='px-2 mt-4 mb-0'>Employee training</h3>
                              <div className='mb-2 mx-2 mt-4 d-flex justify-content-between align-items-center'>
                                <button className="btn btn-outline-primary small py-0 pe-0 w-100 text-black d-flex justify-content-between align-items-center" onClick={() => openVideoModal('employee_training')} style={{ backgroundColor: '#F8F8F8' }}>Upload proof of employee training <img src='/images/upload.svg' alt='upload' /></button>
                              </div>
                            </div>
                          );
                        }
                      })()}

                      {complianceDocData
                        .filter(compliance => compliance.compliance_title === "Training & Awareness")
                        .map((compliance, index) => {
                          const groupedByDocType = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                            if (!acc[uploadDoc.doc_type]) {
                              acc[uploadDoc.doc_type] = [];
                            }
                            acc[uploadDoc.doc_type].push(uploadDoc);
                            return acc;
                          }, {});

                          return (
                            <div className="px-3 pt-0 pb-4 mb-4 border-bottom" key={index}>
                              {Object.entries(groupedByDocType)
                                .filter(([docType]) => docType === "employee_training")
                                .map(([docType, docItems], groupIndex) => (
                                  <div key={groupIndex}>
                                    <div className="px-3">
                                      {docItems.map((uploadDoc, docIndex) => (
                                        <div key={docIndex}>
                                          <div className='d-flex justify-content-between align-items-center my-2'>
                                            <p className="mt-2 mb-1">
                                              <p className="fw-regular text-capitalize mb-0">
                                                Employee training
                                              </p>
                                            </p>
                                            <p className='mb-0'>
                                              <a href='javascript:void(0)'
                                                onClick={() => openVideoModal('employee_training')}
                                                className='mt-3'
                                                style={{ color: '#23A298', textDecoration: 'none' }}
                                              >
                                                <img src='/images/add-circle.svg' alt='Add' className='me-1' />Add
                                              </a>
                                            </p>
                                          </div>

                                          {uploadDoc.documents.map((doc, fileIndex) => (
                                            <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                              <img
                                                src={
                                                  doc.file_type === "pdf"
                                                    ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                    : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                }
                                                alt={doc.file_type}
                                                width="25"
                                                className="me-2 py-1"
                                              />
                                              <div className="flex-grow-1" style={{ wordBreak: 'break-word' }}>{doc.file_name}</div>

                                              <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                                <img src="/images/download-icon.svg" alt="Download" />
                                              </a>

                                              <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                                e.preventDefault();
                                                handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                              }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                                </svg>
                                              </a>
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          );
                        })}


                      {(() => {
                        const trainingAwareness = complianceDocData.find(item => item.compliance_title === "Training & Awareness");

                        const hasIcTrainingDocuments =
                          trainingAwareness &&
                          trainingAwareness.uploadDocument &&
                          trainingAwareness.uploadDocument.some(
                            docGroup => docGroup.doc_type === "ic_training" && docGroup.documents && docGroup.documents.length > 0
                          );

                        if (!hasIcTrainingDocuments) {
                          // Case: IC Training Documents are not present - show title and upload button
                          return (
                            <div className='px-3'>
                              <h3 className='px-3 mt-4 mb-0'>IC (Internal Committee) training</h3>
                              <div className='mb-2 mx-3 mt-4 d-flex justify-content-between align-items-center'>
                                <button className="btn btn-outline-primary small py-0 pe-0 w-100 text-black d-flex justify-content-between align-items-center" onClick={() => openVideoModal('ic_training')} style={{ backgroundColor: '#F8F8F8' }}>Upload proof of IC (Internal Committee) training <img src='/images/upload.svg' alt='upload' /></button>
                              </div>                   
                            </div>
                          );
                        }
                      })()}

                      {complianceDocData
                        .filter(compliance => compliance.compliance_title === "Training & Awareness")
                        .map((compliance, index) => {
                          const groupedByDocType = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                            if (!acc[uploadDoc.doc_type]) {
                              acc[uploadDoc.doc_type] = [];
                            }
                            acc[uploadDoc.doc_type].push(uploadDoc);
                            return acc;
                          }, {});

                          return (
                            <div className="px-3 pt-0 pb-4 mb-4 border-bottom" key={index}>
                              {Object.entries(groupedByDocType)
                                .filter(([docType]) => docType === "ic_training")
                                .map(([docType, docItems], groupIndex) => (
                                  <div key={groupIndex}>
                                    <div className="px-3">
                                      {docItems.map((uploadDoc, docIndex) => (
                                        <div key={docIndex}>
                                          <div className='d-flex justify-content-between align-items-center my-2'>
                                            <p className="mt-2 mb-1">
                                              <p className="fw-regular text-capitalize mb-0">
                                                IC (Internal Committee) training
                                              </p>
                                            </p>
                                            <p className='mb-0'>
                                              <a href='javascript:void(0)'
                                                onClick={() => openVideoModal('ic_training')}
                                                className='mt-3'
                                                style={{ color: '#23A298', textDecoration: 'none' }}
                                              >
                                                <img src='/images/add-circle.svg' alt='Add' className='me-1' />Add
                                              </a>
                                            </p>
                                          </div>

                                          {uploadDoc.documents.map((doc, fileIndex) => (
                                            <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                              <img
                                                src={
                                                  doc.file_type === "pdf"
                                                    ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                    : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                }
                                                alt={doc.file_type}
                                                width="25"
                                                className="me-2 py-1"
                                              />
                                              <div className="flex-grow-1" style={{ wordBreak: 'break-word' }}>{doc.file_name}</div>

                                              <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                                <img src="/images/download-icon.svg" alt="Download" />
                                              </a>

                                              <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                                e.preventDefault();
                                                handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                              }}>
                                                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                  <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                                </svg>
                                              </a>
                                            </div>
                                          ))}
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                            </div>
                          );
                        })}
                      <small className="d-block text-muted mx-4">
                        Your organisation privacy matters – <a href="javascript:void(0);" onClick={openOrganisationPrivacyModal} className="text-muted">learn why we use or collect this information?</a>
                      </small>
                    </div></div>
                  <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom mt-0 py-3 px-4 mb-4'>View Templates</h5>
                      <div className="d-flex justify-content-start w-100 px-3">
                        {templateList.length > 0 ? (
                          <div className="template-library" style={{ display: 'flex', flexDirection: 'row', justifyContent: templateList?.length > 1 ? 'space-evenly' : 'flex-start' }}>
                            {templateList?.slice(0, 2)?.map(template => (
                              <div key={template.id} class="card rounded-4 p-1 col-5 shadow-sm my-2">
                                <img src={template?.thumbnail} alt="template-img" className="img-fluid" />
                                 <h4 className='mt-2 fw-bold' style={{ fontSize: '10px' }}>{template?.title}</h4>
                                          <div className='d-flex flex-wrap align-items-center justify-content-start'>
                        {template?.upload_url?.slice(0, 2).map((file, index) => {
                          const isImageFile = file?.type && (
                            file.type.toLowerCase().includes('png') || 
                            file.type.toLowerCase().includes('jpg') || 
                            file.type.toLowerCase().includes('jpeg') || 
                            file.type.toLowerCase().includes('image')
                          );

                          return isImageFile ? (
                            // <button
                            //   key={index}
                            //   onClick={() => handleDownload(file.url, `${template.title}.${file.type}`)}
                            //   className='btn btn-primary btn-sm px-1 pt-0 pb-1 mx-1 d-flex align-items-center'
                            // >
                            //   {file.type}
                            //   <img
                            //     src='/images/download-arrow.png'
                            //     alt='download-icon'
                            //     width={10}
                            //     height={10}
                            //     className='ms-1'
                            //   />
                            // </button>

                             <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>

                          ) : (
                            <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>
                          );
                        })}
                      </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No templates found.</p>
                        )}
                      </div>
                      <div className='text-center'>
                        <a href='/template_library/email_campaign' className="btn btn-link btn-primary text-white text-decoration-none btn-sm w-75 mt-3 mx-auto">View All</a>
                      </div>
                    </div>
                  </div>
                </div>}

              {complianceData[0]?.menu_title === "Documentation" &&
                <div className="col-md-4 ps-4 pe-0">
                  <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom py-4 px-4 my-0'>Upload Documents</h5>

                      {(() => {
                        const documentation = complianceDocData.find(item => item.compliance_title === "Documentation");

                        const hasDocuments =
                          documentation &&
                          documentation.uploadDocument &&
                          documentation.uploadDocument.some(
                            docGroup => docGroup.documents && docGroup.documents.length > 0
                          );

                        if (!hasDocuments) {
                          // Case: Documents are not present
                          return (
                            <div className='px-4'>
                              <h3 className='mt-4 mb-4'>Annual Report Submission</h3>
                              <div className='mb-2 d-flex justify-content-between align-items-center'>
                                <button
                                  className="btn btn-outline-primary small py-0 pe-0 w-100 text-black d-flex justify-content-between align-items-center"
                                  onClick={() => openVideoModal('annual_report')}
                                  style={{ backgroundColor: '#F8F8F8' }}
                                >
                                  Upload your organisation Annual Report
                                  <img src='/images/upload.svg' alt='upload' />
                                </button>
                              </div>
                            </div>
                          );
                        }
                      })()}

                      {complianceDocData
                        .filter(compliance => compliance.compliance_title === "Documentation")
                        .map((compliance, index) => {
                          const groupedByDocType = compliance.uploadDocument.reduce((acc, uploadDoc) => {
                            if (!acc[uploadDoc.doc_type]) {
                              acc[uploadDoc.doc_type] = [];
                            }
                            acc[uploadDoc.doc_type].push(uploadDoc);
                            return acc;
                          }, {});

                          return (
                            <div className="px-3 pt-0 pb-4 mb-4 border-bottom" key={index}>
                              {Object.entries(groupedByDocType).map(([docType, docItems], groupIndex) => (
                                <div key={groupIndex}>
                                  <div className="px-3">
                                    {docItems.map((uploadDoc, docIndex) => (
                                      <div key={docIndex}>
                                        <div className='d-flex justify-content-between align-items-center my-2'>
                                          <p className="mt-2 mb-1">
                                            <p className="fw-regular text-capitalize mb-0">
                                              Annual report submission
                                            </p>
                                          </p>
                                          <p className='mb-0'>
                                            <a href='javascript:void(0)'
                                              onClick={() => openVideoModal('annual_report')}
                                              className='mt-3'
                                              style={{ color: '#23A298', textDecoration: 'none' }}
                                            >
                                              <img src='/images/add-circle.svg' alt='Add' className='me-1' />Add
                                            </a>
                                          </p>
                                        </div>

                                        {uploadDoc.documents.map((doc, fileIndex) => (
                                          <div className="d-flex align-items-center border p-2 rounded bg-light mb-2" key={fileIndex}>
                                            <img
                                              src={
                                                  doc.file_type === "pdf"
                                                    ? "https://img.icons8.com/color/48/000000/pdf.png"
                                                    : doc.file_type === "png" || doc.file_type === "jpg" || doc.file_type === "jpeg"
                                                    ? "https://img.icons8.com/color/48/000000/png.png"
                                                    : "https://img.icons8.com/color/48/000000/word.png"
                                                }
                                              alt={doc.file_type}
                                              width="25"
                                              className="me-2 py-1"
                                            />
                                            <div className="flex-grow-1" style={{ wordBreak: 'break-word' }}>{doc.file_name}</div>

                                            <a href={doc.url} target='_blank' className="text-decoration-none text-primary me-2 d-flex align-items-center border-right" download>
                                              <img src="/images/download-icon.svg" alt="Download" />
                                            </a>

                                            <a href="#" className="text-danger text-decoration-none ms-1 d-flex align-items-center border-left" onClick={(e) => {
                                              e.preventDefault();
                                              handleDeleteDoc(compliance.compliance_id, uploadDoc.doc_type, doc);
                                            }}>
                                              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-trash me-1" viewBox="0 0 16 16">
                                                <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 0A.5.5 0 0 1 9 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5z" />
                                                <path fillRule="evenodd" d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 1 1 0-2h3.086A1.5 1.5 0 0 1 7 .5h2A1.5 1.5 0 0 1 10.414 2H13.5a1 1 0 0 1 1 1zM4.118 4l.372 9h7l.372-9H4.118z" />
                                              </svg>
                                            </a>
                                          </div>
                                        ))}
                                      </div>
                                    ))}
                                  </div>
                                </div>
                              ))}
                            </div>
                          );
                        })}
                      <small className="d-block text-muted mx-4">
                        Your organisation privacy matters – <a href="javascript:void(0);" onClick={openOrganisationPrivacyModal} className="text-muted">learn why we use or collect this information?</a>
                      </small>
                    </div></div>
                  <div className="card mb-4">
                    <div className="card-body px-0 pt-0">
                      <h5 className='text-black font-weight-600 font-26 border-bottom mt-0 py-3 px-4 mb-4'>View Templates</h5>
                      <div className="d-flex justify-content-start w-100 px-3">
                        {templateList.length > 0 ? (
                          <div className="template-library" style={{ display: 'flex', flexDirection: 'row', justifyContent: templateList?.length > 1 ? 'space-evenly' : 'flex-start' }}>
                            {templateList?.slice(0, 2)?.map(template => (
                              <div key={template.id} class="card rounded-4 p-1 col-5 shadow-sm my-2">
                                <img src={template?.thumbnail} alt="template-img" className="img-fluid" />
                                 <h4 className='mt-2 fw-bold' style={{ fontSize: '10px' }}>{template?.title}</h4>
                                          <div className='d-flex flex-wrap align-items-center justify-content-start'>
                        {template?.upload_url?.slice(0, 2).map((file, index) => {
                          const isImageFile = file?.type && (
                            file.type.toLowerCase().includes('png') || 
                            file.type.toLowerCase().includes('jpg') || 
                            file.type.toLowerCase().includes('jpeg') || 
                            file.type.toLowerCase().includes('image')
                          );

                          return isImageFile ? (
                            // <button
                            //   key={index}
                            //   onClick={() => handleDownload(file.url, `${template.title}.${file.type}`)}
                            //   className='btn btn-primary btn-sm px-1 pt-0 pb-1 mx-1 d-flex align-items-center'
                            // >
                            //   {file.type}
                            //   <img
                            //     src='/images/download-arrow.png'
                            //     alt='download-icon'
                            //     width={10}
                            //     height={10}
                            //     className='ms-1'
                            //   />
                            // </button>

                             <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>

                          ) : (
                            <a
                              key={index}
                              href={file?.url}
                              className='btn btn-primary btn-sm px-1 pt-0 pb-0 mx-1 d-flex align-items-center'
                              target='_blank'
                              rel='noopener noreferrer'
                              download={`${template?.title}-${file?.type}`}
                              style={{fontSize: '10px'}}
                            >
                              {file?.type}
                              <img
                                src='/images/download-arrow.png'
                                alt='download-icon'
                                width={10}
                                height={10}
                                className='ms-1'
                              />
                            </a>
                          );
                        })}
                      </div>
                              </div>
                            ))}
                          </div>
                        ) : (
                          <p>No templates found.</p>
                        )}
                      </div>
                      <div className='text-center'>
                        <a href='/template_library/annual_report' className="btn btn-link btn-primary text-white text-decoration-none btn-sm w-75 mt-3 mx-auto">View All</a>
                      </div>
                    </div>
                  </div>
                </div>}
            </div>}

          {loader ? <Loader /> :
            <Modal
              isOpen={isModalOpen}
              onRequestClose={closeVideoModal}
              contentLabel="Upload Documents Modal"
              className='bg-white border-radius-20 w-25 p-4'
            >

              <div className="text-center mb-2 border-bottom">
                <h5 className="font-26 fw-bold mb-3">Upload Documents</h5>
              </div>
              <div className="modal-body text-center mt-3 px-0">
                <p className="font-16 text-gray  mt-1 mb-0">Supported formats include Doc, Pdf, Png</p>
                <p className="font-16 fw-bold mb-0">Max file size: 10MB</p>
                <div {...getRootProps()} className="upload-image text-center mt-4 py-5 rounded-3 mb-4 mx-2" style={{ border: "2px dashed #C7C7C7", background: "#F5F5F5" }}>
                  <input {...getInputProps()} />

                  <div className="mb-2" style={{ fontSize: "2rem", color: "#ccc" }}>
                    <img src="/images/upload-file-icon.svg" alt="upload-icon" style={{ maxWidth: "30px", height: "auto" }} />
                  </div>
                  <p className="text-muted mb-1">Drag and drop your file here
                    or
                    <a href='javascript:void(0)' className="px-1 mt-1 text-decoration-underline" style={{ color: "#146EF6" }} >
                      Browse
                    </a>
                  </p>
                  {selectedFiles.length > 0 && (
                    <p className='pt-2'>{selectedFiles.map(file => file.name).join(', ')}</p>
                  )}
                </div>

                <div className="text-end">
                  <button type="button" className="btn btn-secondary py-2 px-4 border-radius-50 font-14 me-2" onClick={closeVideoModal}>
                    Cancel
                  </button>
                  <button type="button" className="btn btn-primary py-2 px-4 font-14 border-radius-50" onClick={handleUploadDocument}>
                    Upload
                  </button>
                </div>
              </div>
            </Modal>}

        </div>
      </div>

      {!confirm && 
        <Modal
          isOpen={isPoshCompilanceModalOpen}
          onRequestClose={closePoshCompilanceModal}
          contentLabel="POSH Compliance Modal"
          className="bg-white w-75 p-0"
        >
          <POSHComplianceModal
            onRequestClose={closePoshCompilanceModal}
            onConfirm={sendAcceptance}
          />
        </Modal>
       }  

      <Modal
        isOpen={isOrganisationPrivacyModalOpen}
        onRequestClose={closeOrganisationPrivacyModal}
        contentLabel="Organisation Privacy Modal"
        className="bg-white p-0"
      >
        <OrganisationPrivacyModal
          onRequestClose={closeOrganisationPrivacyModal}
          onConfirm={closeOrganisationPrivacyModal}
        />
      </Modal>

    </div>

  );
};

export default Compliance;